/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let totalCountURL = root.memberFiltersTotalCountUrl.link;
let memberFiltersForSignUpApiURL = root.memberFiltersForSignUpApiUrl.link;
let memberConnectedUsersApiUrl = root.memberConnectedUsersApiUrl.link;
let connectedMemberCountApiUrl = root.connectedMemberCountApiUrl.link;
import Vue from 'vue'
export default {
  state: {
    getMemberFilterCountState:{},
    memberConnectedUsersListState:{},
    getConnectedMemberCountState:{}
  },
  mutations: {
    getMemberFilterCountMutation(state, value) {
      Vue.set(state, 'getMemberFilterCountState', value);
    },
    memberConnectedUsersListMutation(state, value) {
      Vue.set(state, 'memberConnectedUsersListState', value);
    },
    getConnectedMemberCountMutation(state, value) {
      Vue.set(state, 'getConnectedMemberCountState', value);
    },
  },
  actions: {
    // Get Connected Member Filter Count
    getConnectedMemberCountFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(connectedMemberCountApiUrl, payload).then(res => {
              context.commit('getConnectedMemberCountMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Filter Count
    getMemberFilterCountFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(totalCountURL, payload).then(res => {
              context.commit('getMemberFilterCountMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Member Filter For Signup
    getMemberFilterListForSignupFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersForSignUpApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Connnected Users List
    memberConnectedUsersListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberConnectedUsersApiUrl, payload).then(res => {
              context.commit('memberConnectedUsersListMutation', res);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getMemberFilterCountGetters: state => state.getMemberFilterCountState,
    memberConnectedUsersListGetters: state => state.memberConnectedUsersListState,
    getConnectedMemberCountGetters: state => state.getConnectedMemberCountState
  }
}